export const environment = {
  production: false,
  apiUrl: 'https://api-dev.hrci.org/api',
  auth0: {
    domain: 'hrci.auth0.com',
    clientId: 'wA2Y0UNfWCsNcdP9uIQmHh8dGZWcB6Xv'
  }
};
